import { render } from "./MainControlOfBoxes.vue?vue&type=template&id=695239ce&scoped=true"
import script from "./MainControlOfBoxes.vue?vue&type=script&lang=js"
export * from "./MainControlOfBoxes.vue?vue&type=script&lang=js"

import "./MainControlOfBoxes.vue?vue&type=style&index=0&id=695239ce&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695239ce"]])

export default __exports__